import { useState } from "react";

const faqs = [
  {
    q: "O certificado pode ser feito online?",
    a: "Sim. A emissão pode ser feita por videoconferência, com orientação da AVcertifica durante o processo.",
  },
  {
    q: "O certificado vale 10 anos?",
    a: "O prazo de validade do certificado depende do plano contratado. A renovação facilitada permite que, após a primeira validação por videoconferência, as próximas renovações sejam mais rápidas por até 10 anos, conforme a tecnologia biométrica disponível.",
  },
  {
    q: "Vou precisar fazer videoconferência todo ano?",
    a: "Não necessariamente. Após a primeira emissão com videoconferência, as renovações futuras podem ser simplificadas através de validação biométrica, sem precisar repetir todo o processo.",
  },
  {
    q: "Vocês ajudam na instalação?",
    a: "Sim. Nosso suporte orienta na instalação do certificado para que você comece a usar sem dificuldades.",
  },
  {
    q: "Serve para emitir nota fiscal?",
    a: "Sim. O e-CNPJ A1 é ideal para emissão de NF-e e NFC-e, além de acesso a sistemas fiscais e assinatura de documentos empresariais.",
  },
  {
    q: "A AVcertifica atende somente em Blumenau?",
    a: (
      <>
        Não. Atendemos clientes de todo o Brasil por videoconferência. Para quem prefere não realizar a etapa por videoconferência, o atendimento{" "}
        <strong className="text-foreground-800">presencialmente em Blumenau/SC</strong> ou{" "}
        <strong className="text-foreground-800">externo na sua localidade</strong>. No atendimento externo, é aplicada uma taxa de deslocamento, que pode ser consultada pelo telefone{" "}
        <a href="tel:+5547991891311" className="font-medium text-accent-600 underline underline-offset-2 hover:text-accent-700 transition-colors whitespace-nowrap">
          (47) 99189-1311
        </a>.
      </>
    ),
  },
  {
    q: "Os certificados são emitidos por qual Autoridade Certificadora?",
    a: "Os certificados são emitidos por meio da Soluti, uma Autoridade Certificadora de 1º nível na ICP-Brasil, garantindo validade jurídica e segurança.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="relative py-20 md:py-24 bg-background-50">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <div className="flex justify-center">
            <div className="inline-flex items-center gap-2 rounded-full border border-accent-500/30 bg-accent-50 px-3 py-1 text-xs font-medium text-accent-600">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
              Dúvidas frequentes
            </div>
          </div>
          <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 font-heading">
            Perguntas que a gente <span className="text-accent-500">responde direto</span>
          </h2>
        </div>

        <div className="mt-12 space-y-3">
          {faqs.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className={`rounded-2xl border transition-colors ${
                  isOpen ? "border-accent-400 bg-background-50" : "border-secondary-200 bg-background-50"
                }`}
              >
                <button
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                  onClick={() => setOpenIndex(isOpen ? null : idx)}
                  aria-expanded={isOpen}
                >
                  <span className="font-medium text-foreground-800">{faq.q}</span>
                  <span
                    className={`shrink-0 inline-flex h-8 w-8 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-accent-500 text-background-50" : "bg-accent-100 text-accent-600"
                    }`}
                  >
                    <i className={`ri-${isOpen ? "subtract" : "add"}-line text-sm`}></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all ${
                    isOpen ? "max-h-96" : "max-h-0"
                  }`}
                >
                  <p className="px-6 pb-6 text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}